module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-60.a49348cf.svg";